export enum MobileDeviceType {
	iOS = "iOS",
    Android = "Android",
}